module.exports = __webpack_public_path__ + "e741cfb1ee4df186a734109f8441a80e.png";